import styled from "styled-components";
import {
  AddButton as DefaultAddButton,
  WarnButton as DefaultWarnButton,
} from "../../../Common/Components/FormComponents";

export const AddButton = styled(DefaultAddButton)`
  width: 100%;

  @media (${({ theme }) => theme.breakpoints.min800}) {
    width: 60%;
  }
`;

export const WarnButton = styled(DefaultWarnButton)`
  width: 100%;
  margin-top: 1rem;

  @media (${({ theme }) => theme.breakpoints.min800}) {
    width: 70%;
    margin-left: 2rem;
  }
`;
